import React from "react";
import styled from "styled-components";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import { lightTheme } from "../../styles/theme";
import chooseAssets from "../../assets/chooseAssets.png";
import assets from "../../assets/assets.png";
import dashboardSmall from "../../assets/dashboardSmall.png";
import dashboard from "../../assets/dashboard.png";
import notification from "../../assets/notification.png";
import detailedDashboard from "../../assets/detailedDashboard.png";
import pairs from "../../assets/pairs.svg";
import liveFeed from "../../assets/liveFeed.png";
import { HASH_ROUTES } from "../../constants/routes";
import { useTranslation } from "../../lang/TranslationContext";
import { AnimateIn } from "../../components/AnimateIn";

export const Features = () => {
  const { width } = useWindowDimensions();
  const { translations } = useTranslation();

  const DesktopView = (
    <>
      <VerticalAlign>
        <AnimateIn msDelay={0}>
          <DefaultBlock width={407} height={467} bigText>
            <div>
              <img src={chooseAssets} alt="Feature" />
            </div>
            <p>
              {translations.landing.features.autonomous1}
              <br />
              {translations.landing.features.autonomous2}
            </p>
          </DefaultBlock>
        </AnimateIn>
        <AnimateIn msDelay={250} direction="right">
          <DefaultBlock width={407} height={303}>
            <div>
              <img src={dashboardSmall} alt="Feature" />
            </div>
            <p>
              {translations.landing.features.optimized1}
              <br />
              {translations.landing.features.optimized2}
            </p>
          </DefaultBlock>
        </AnimateIn>
      </VerticalAlign>
      <VerticalAlign>
        <AnimateIn msDelay={250}>
          <DefaultBlock width={318} height={303} alignEnd bigImage>
            <div>
              <img src={pairs} alt="Feature" />
            </div>
            <p>{translations.landing.features.pairScreener}</p>
          </DefaultBlock>
        </AnimateIn>
        <AnimateIn msDelay={500} direction="down">
          <DefaultBlock width={318} height={202}>
            <div>
              <img src={notification} alt="Feature" />
            </div>
            <p>{translations.landing.features.notifications}</p>
          </DefaultBlock>
        </AnimateIn>
        <AnimateIn msDelay={250}>
          <DefaultBlock width={318} height={240}>
            <div>
              <img src={assets} alt="Feature" />
            </div>
            <p>{translations.landing.features.assetsSupport}</p>
          </DefaultBlock>
        </AnimateIn>
      </VerticalAlign>

      <VerticalAlign>
        <AnimateIn msDelay={500}>
          <DefaultBlock width={556} height={345}>
            <div>
              <img src={dashboard} alt="Feature" />
            </div>
            <p>{translations.landing.features.multifunctionalDashboard}</p>
          </DefaultBlock>
        </AnimateIn>
        <HorizontalAlign>
          <AnimateIn msDelay={500}>
            <DefaultBlock width={266} height={424} imagePadding>
              <div>
                <img src={liveFeed} alt="Feature" />
              </div>
              <p>{translations.landing.features.liveFeedStatistics}</p>
            </DefaultBlock>
          </AnimateIn>
          <AnimateIn msDelay={750} direction="left">
            <DefaultBlock width={266} height={424} alignEnd imagePadding>
              <div>
                <img src={detailedDashboard} alt="Feature" />
              </div>
              <p>{translations.landing.features.detailedDashboard}</p>
            </DefaultBlock>
          </AnimateIn>
        </HorizontalAlign>
      </VerticalAlign>
    </>
  );

  const TabletView = (
    <VerticalAlign>
      <HorizontalAlign>
        <AnimateIn msDelay={0}>
          <DefaultBlock width={353} height={441} bigText>
            <div>
              <img src={chooseAssets} alt="Feature" />
            </div>
            <p>
              {translations.landing.features.autonomous1}
              <br />
              {translations.landing.features.autonomous2}
            </p>
          </DefaultBlock>
        </AnimateIn>
        <VerticalAlign>
          <AnimateIn msDelay={250} direction="left">
            <DefaultBlock width={305} height={224}>
              <div>
                <img src={assets} alt="Feature" />
              </div>
              <p>{translations.landing.features.assetsSupport}</p>
            </DefaultBlock>
          </AnimateIn>
          <AnimateIn msDelay={500} direction="left">
            <DefaultBlock width={305} height={192} imagePadding>
              <div>
                <img src={notification} alt="Feature" />
              </div>
              <p>{translations.landing.features.notifications}</p>
            </DefaultBlock>
          </AnimateIn>
        </VerticalAlign>
      </HorizontalAlign>
      <HorizontalAlign>
        <VerticalAlign>
          <AnimateIn msDelay={500}>
            <DefaultBlock width={266} height={335} imagePadding>
              <div>
                <img src={liveFeed} alt="Feature" />
              </div>
              <p>{translations.landing.features.liveFeedStatistics}</p>
            </DefaultBlock>
          </AnimateIn>
          <AnimateIn msDelay={0} direction="right">
            <DefaultBlock width={266} height={335}>
              <div>
                <img src={dashboardSmall} alt="Feature" />
              </div>
              <p>
                {translations.landing.features.optimized1}
                <br />
                {translations.landing.features.optimized2}
              </p>
            </DefaultBlock>
          </AnimateIn>
        </VerticalAlign>
        <VerticalAlign>
          <AnimateIn msDelay={100}>
            <DefaultBlock width={392} height={347} alignEnd>
              <div>
                <img src={detailedDashboard} alt="Feature" />
              </div>
              <p>{translations.landing.features.detailedDashboard}</p>
            </DefaultBlock>
          </AnimateIn>
          <AnimateIn msDelay={500} direction="left">
            <DefaultBlock width={392} height={323} alignEnd bigImage>
              <div>
                <img src={pairs} alt="Feature" />
              </div>
              <p>{translations.landing.features.pairScreener}</p>
            </DefaultBlock>
          </AnimateIn>
        </VerticalAlign>
      </HorizontalAlign>
      <AnimateIn msDelay={500}>
        <DefaultBlock width={684} height={345}>
          <div>
            <img src={dashboard} alt="Feature" />
          </div>
          <p>{translations.landing.features.multifunctionalDashboard}</p>
        </DefaultBlock>
      </AnimateIn>
    </VerticalAlign>
  );

  const MobileView = (
    <AnimateIn msDelay={200}>
      <VerticalAlign isMobile>
        <DefaultBlock isMobile width={width} height={290} bigText>
          <div>
            <img src={chooseAssets} alt="Feature" />
          </div>
          <p>
            {translations.landing.features.autonomous1}
            <br />
            {translations.landing.features.autonomous2}
          </p>
        </DefaultBlock>

        <DefaultBlock isMobile width={width} height={290}>
          <div>
            <img src={assets} alt="Feature" />
          </div>
          <p>{translations.landing.features.assetsSupport}</p>
        </DefaultBlock>

        <DefaultBlock isMobile width={width} height={290}>
          <div>
            <img src={dashboard} alt="Feature" />
          </div>
          <p>{translations.landing.features.multifunctionalDashboard}</p>
        </DefaultBlock>

        <DefaultBlock isMobile width={width} height={290}>
          <div>
            <img src={dashboardSmall} alt="Feature" />
          </div>
          <p>
            {translations.landing.features.optimized1}
            <br />
            {translations.landing.features.optimized2}
          </p>
        </DefaultBlock>

        <DefaultBlock isMobile width={width} height={290} imagePadding>
          <div>
            <img src={liveFeed} alt="Feature" />
          </div>
          <p>{translations.landing.features.liveFeedStatistics}</p>
        </DefaultBlock>

        <DefaultBlock isMobile width={width} height={290} imagePadding>
          <div>
            <img src={notification} alt="Feature" />
          </div>
          <p>{translations.landing.features.notifications}</p>
        </DefaultBlock>

        <DefaultBlock isMobile width={width} height={290} alignEnd>
          <div>
            <img src={detailedDashboard} alt="Feature" />
          </div>
          <p>{translations.landing.features.detailedDashboard}</p>
        </DefaultBlock>

        <DefaultBlock isMobile width={width} height={290} alignEnd bigImage>
          <div>
            <img src={pairs} alt="Feature" />
          </div>
          <p>{translations.landing.features.pairScreener}</p>
        </DefaultBlock>
      </VerticalAlign>
    </AnimateIn>
  );

  return (
    <Wrap id={HASH_ROUTES.features}>
      <Heading>{translations.landing.features.heading}</Heading>
      <SubHeading>{translations.landing.features.subheading}</SubHeading>
      <InnerWrap>
        {width > 1435 ? DesktopView : width > 740 ? TabletView : MobileView}
      </InnerWrap>
    </Wrap>
  );
};

const Wrap = styled.div`
  width: 100%;
  background: rgba(252, 253, 255, 1);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 100px;

  @media screen and (max-width: 700px) {
    padding-top: 60px;
  }
`;

const Heading = styled.h1`
  margin: 0;
  margin-bottom: 16px;
  color: ${lightTheme.typography.primary};
  font-size: 42px;
  font-weight: 700;
  text-align: center;
  max-width: 900px;
  padding: 0 24px;

  @media screen and (max-width: 700px) {
    font-size: 30px;
  }
`;

const SubHeading = styled.p`
  margin: 0;
  margin-bottom: 20px;
  color: ${lightTheme.typography.secondary};
  font-size: 18px;
  font-weight: 400;
  text-align: center;
  max-width: 700px;
  padding: 0 24px;
  line-height: 1.6;

  @media screen and (max-width: 700px) {
    font-size: 16px;
  }
`;

const InnerWrap = styled.div`
  width: 100%;
  max-width: 1440px;
  display: flex;
  justify-content: center;
  padding: 50px 50px 100px;
  gap: 25px;

  @media screen and (max-width: 450px) {
    padding: 25px;
  }
`;

const VerticalAlign = styled.div<{ isMobile?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 25px;
  width: ${({ isMobile }) => isMobile && "100%"};
`;

const HorizontalAlign = styled.div`
  display: flex;
  gap: 25px;
`;

const DefaultBlock = styled.div<{
  width: number;
  height: number;
  isMobile?: boolean;
  alignEnd?: boolean;
  bigImage?: boolean;
  imagePadding?: boolean;
  bigText?: boolean;
}>`
  height: ${({ height }) => height}px;
  width: ${({ width, isMobile }) => (isMobile ? "100%" : width + "px")};
  max-width: ${({ width }) => width}px;
  background: white;
  border-radius: 20px;
  box-shadow: 0 16px 32px -4px rgba(12, 12, 13, 0.1),
    0 4px 4px -4px rgba(12, 12, 13, 0.05);

  display: flex;
  flex-direction: column;
  align-items: ${({ alignEnd }) => (alignEnd && "flex-end") || "center"};
  justify-content: space-between;
  overflow: hidden;

  > section {
    width: 100%;
    padding: 12px;
  }

  > div {
    width: ${({ imagePadding }) =>
      (imagePadding && "calc(100% - 30px)") || "100%"};
    display: flex;
    justify-content: ${({ alignEnd }) => (alignEnd && "flex-end") || "center"};
    max-width: 330px;
    margin-top: ${({ bigImage }) => (bigImage && "-46px") || "0px"};
    height: ${({ bigImage, bigText }) =>
      (bigImage && "100%") ||
      (bigText && "calc(100% - 115px)") ||
      "calc(100% - 85px)"};
    z-index: 1;

    img {
      height: ${({ imagePadding }) => (imagePadding && "") || "100%"};
      width: ${({ imagePadding }) => (imagePadding && "100%") || ""};
      object-fit: ${({ imagePadding }) => imagePadding && "contain"};
    }
  }

  p {
    width: 100%;
    text-align: center;
    color: ${lightTheme.typography.primary};
    font-size: 17px;
    font-weight: 600;
    margin-bottom: 25px;
    z-index: 2;
    position: relative;

    @media screen and (min-width: 1435px) {
      font-size: 24px;
    }

    @media screen and (min-width: 740px) {
      font-size: 21px;
    }
  }
`;
